/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import ReactDOM from 'react-dom';
import { ToastProvider } from 'react-toast-notifications';
import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-circular-progressbar/dist/styles.css';
import { ApolloProvider } from 'react-apollo';
import Main from './Main';
import client from './client';
import awsConfig from './config/awsConfig';

awsConfig();

const rootElement = (
  <ApolloProvider client={client}>
    <ToastProvider
      placement="top-center"
      autoDismiss
      autoDismissTimeout={6000}
    >
      <Main />
    </ToastProvider>
  </ApolloProvider>
);
ReactDOM.render(rootElement, document.getElementById('root'));
